import { useUserInfo } from './useUserInfo';

export const useIsAdmin = () => useUserInfo().user.isAdmin;
